<template>
  <div>
    <div class="title">
      我的传话
    </div>
    <div class="main">
      <!-- 空数据状态 -->
      <van-empty v-if="showEmpty" description="还没有任何传话哦，快去发送一条吧">
        <van-button round type="danger" to="/messenger" class="bottom-button" color="#00D477">
          去传话
        </van-button>

        <!-- 未绑定手机号 → 显示提示 + 登录按钮 -->
        <div v-if="!isBindPhone" class="login-tip">
          <span class="tip-text">找不到发送记录？登录试试</span>
          <van-button round type="success" class="bottom-button" color="#00D477" @click="showBindPhoneDialog = true">
            登录
          </van-button>
        </div>
      </van-empty>

      <div class="list-wrapper"  v-if="!showEmpty">
        <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="已加载全部"
            @load="loadMore"
        >
          <van-empty v-if="messageList.length === 0 && !loading" description="暂无数据" />

          <div v-else class="list-body">
            <van-swipe-cell
                v-for="item in messageList"
                :key="item.id"
                :right-width="60"
                class="swipe-cell"
            >
              <div class="item-card" @click="handleItemClick(item)">
                <div class="content">
                  <div class="row">
                    <span class="label">社交软件：</span>
                    <span class="val">{{ item.channelName }}</span>
                  </div>
                  <div class="row">
                    <span class="label">联系方式：</span>
                    <span class="val">{{ item.accountInfo }}</span>
                  </div>
                  <div class="row">
                    <span class="label">传话时间：</span>
                    <span class="val">{{ formatTime(item.sendTime) }}</span>
                  </div>
                  <div class="row">
                    <span class="label">传话状态：</span>
                    <span class="val" :class="{ red: true }">{{ getMsgStatus(item.msgStatus) }}</span>
                  </div>
                </div>
                <van-icon name="arrow" class="arrow" />
              </div>

              <template #right>
                <div class="del-btn" @click.stop="handleDelete(item.id)">删除</div>
              </template>
            </van-swipe-cell>
          </div>
        </van-list>
      </div>
    </div>

    <BindPhoneDialog
        v-model:show="showBindPhoneDialog"
        dialog-title="登录"
        :show-tips="false"
        @bind-success="handleBindSuccess"
        @close="handleBindClose"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import {
  Button as VanButton,
  Empty as VanEmpty,
  SwipeCell as VanSwipeCell,
  Dialog,
  Toast,
  List as VanList,
  Icon as VanIcon
} from 'vant';
import BindPhoneDialog from '@/components/BindPhoneDialog.vue';
import { getUserInfo } from '@/api/user';
import {getMessengerList} from '@/api/messenger'
const router = useRouter();

// 数据
const showEmpty = ref(false);
const showBindPhoneDialog = ref(false);
const isBindPhone = ref(true);
const messageList = ref([]);
const loading = ref(false);
const finished = ref(false);

// 获取列表
const getList = async () => {
  try {
    loading.value = true
    getMessengerList().then(res => {
      // 后端数据 => 前端下拉格式
      messageList.value = res.data.data.map(item => ({
        ...item,
      }));
      loading.value = false
      finished.value = true
      showEmpty.value = messageList.value.length === 0;
    })

  } catch (err) {
    messageList.value = [];
    loading.value = false
    finished.value = true
  }
};

// 加载更多
const loadMore = () => {
  getList();
};


// 时间格式化：年月日 时分秒
const formatTime = (time) => {
  const d = new Date(time)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  const ss = String(d.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hh}:${mm}:${ss}`
}

const getMsgStatus = (type) => {
  if (type === 0) {
    return "已发送"
  }else if (type === 1) {
    return '未发送'
  }else if (type === 2) {
    return '发送失败'
  }else if (type === 3) {
    return '已取消'
  }else if (type === 4) {
    return '审核中'
  }else if (type === 5) {
    return '审核不过'
  }else  {

    return '已发送'
  }
}

const handleItemClick = (item) => {
  localStorage.setItem('currentMsgItem', JSON.stringify(item))
  router.push({
    name: 'MsgDetail',
    params: { item: JSON.stringify(item)  }
  })
}
const handleBack = () => history.back()

// 根据ID删除（彻底解决不归位）
const handleDelete = (id) => {
  messageList.value = messageList.value.filter(item => item.id !== id)
  Toast('删除成功')
}

// 绑定成功
const handleBindSuccess = () => {
  isBindPhone.value = true;
  showBindPhoneDialog.value = false;
  getList();
};

// 关闭绑定
const handleBindClose = () => {
  showBindPhoneDialog.value = false;
};

// 初始化
onMounted(async () => {
  getList();

  const res = await getUserInfo();
  if (res.data.code === '00000') {
    isBindPhone.value = !!res.data.data.phone;
  }
});
</script>

<style scoped>
.main {
  background: #f7f7f7;
  padding: 0 15px 65px 15px;
  height: 100%;
  box-sizing: border-box;
}
.title {
  font-size: 22px;
  color: #292833;
  font-weight: bold;
  height: 40px;
  padding: 15px;
  line-height: 40px;
  z-index: 999;
  background: #f7f7f7;
  position: sticky;
  top: 0;
}
.bottom-button {
  width: 160px;
  height: 40px;
  margin-top: 10px;
}
.login-tip {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.tip-text {
  font-size: 14px;
  color: #999;
  margin-bottom: 10px;
}
.row {
  display: flex;
  padding: 4px 0;
}
.label {
  width: 90px;
  color: #666;
}
.val {
  color: #333;
}
.red {
  color: #f56c6c;
}
.item-card {
  background: #fff;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.del-btn {
  background: #f56c6c;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
}
</style>